//
// Manually importing these from @ux/inline-styles until
// we can break apart variable definitions from
// require('@ux/inline-styles/variables/index.json').
//
export default {
  /** default size for a small spinner */
  uxSpinnerSmSize: '18px',
  /** default size for a medium spinner */
  uxSpinnerMdSize: '36px',
  /** default size for a large spinner */
  uxSpinnerLgSize: '72px',
  /** default stroke width for a small spinner */
  uxSpinnerSmStrokeWidth: '2',
  /** default stroke width for a medium spinner */
  uxSpinnerMdStrokeWidth: '4',
  /** default stroke width for a large spinner */
  uxSpinnerLgStrokeWidth: '6',
  /** default duration for one spin */
  uxSpinnerDuration: '1.2s'
};



// WEBPACK FOOTER //
// ./node_modules/@ux/spinner/definitions.js